import React from "react";
import { Route, Routes } from "react-router-dom";
import WorkshopServices from "../layout/workshopService/WorkshopServices";
import AddWorkshopService from "../layout/workshopService/AddWorkshopService";

function WorkshopServicePage() {
    return (
        <>
            <Routes>
                <Route path="/" element={<WorkshopServices />} />
                <Route path="/add" element={<AddWorkshopService />} />
                <Route path="/update/:id" element={<AddWorkshopService />} />
            </Routes>
        </>
    );
}

export default WorkshopServicePage;
